import React from 'react';
import './styles.scss';

import leadGenerationImg from '../../public/assets/images/lead-generation.png';
import webConversionImg from '../../public/assets/images/web-conversion.png';
import audienceReachImg from '../../public/assets/images/audience-reach.png';
import { FilterObjectiveTypes } from '../../enums';

type Props = {
  objective: FilterObjectiveTypes;
};

const ObjectiveCell = function ({ objective }: Props) {
  let renderedComponent = null;

  switch (objective) {
    case FilterObjectiveTypes.leadGeneration:
      renderedComponent = (
        <>
          <span className="ObjectiveCell-lead-generation">
            <img alt="lead generation" src={leadGenerationImg} />
          </span>
          <span>Lead Generation</span>
        </>
      );
      break;

    case FilterObjectiveTypes.audienceReach:
      renderedComponent = (
        <>
          <span className="ObjectiveCell-audience-reach">
            <img alt="audience reach" src={audienceReachImg} />
          </span>
          <span>Audience Reach</span>
        </>
      );
      break;

    case FilterObjectiveTypes.webConversion:
      renderedComponent = (
        <>
          <span className="ObjectiveCell-web-conversion">
            <img alt="web conversion" src={webConversionImg} />
          </span>
          <span>Web Conversion</span>
        </>
      );
      break;
    default:
  }

  return <div className="ObjectiveCell">{renderedComponent}</div>;
};

export default ObjectiveCell;
